/* Peanuts · stato variante, pulsante "Avvisami quando è disponibile" e finestra con il form Klaviyo.
   Caricato solo dal blocco peanuts-scheda (template product.peanuts). Tema: Enterprise 1.4.2. */
(function () {
  'use strict';

  /* Blocco "Pulsanti di acquisto" della scheda principale: quantità, carrello e pagamento rapido
     stanno tutti dentro <product-form>. */
  var PEANUTS_SELETTORE_ACQUISTO = '[id$="__main"] product-form';

  /* Evento inviato a Klaviyo quando il form nella finestra viene inviato: porta prodotto e variante,
     così Francesca può segmentare le richieste per singola creazione. Nome da validare con lei. */
  var EVENTO_KLAVIYO = 'Peanuts Richiesta Avviso';

  var TESTI = { it: 'Quantità limitata', en: 'Limited quantity' };

  function init() {
    var azione = document.querySelector('[data-peanuts-azione]');
    var mappaEl = document.querySelector('[data-peanuts-map]');
    if (!azione || !mappaEl) return;

    var mappa = {};
    try { mappa = JSON.parse(mappaEl.textContent); } catch (e) { mappa = {}; }
    var lingua = azione.getAttribute('data-lingua') === 'it' ? 'it' : 'en';
    var slotLabel = document.querySelectorAll('[data-peanuts-label-slot]');
    var modale = document.querySelector('[data-peanuts-modale]');
    var varianteCorrente = azione.getAttribute('data-variante');
    var varianteForzata = null;

    function leggiVariante() {
      if (varianteForzata) { var f = varianteForzata; varianteForzata = null; return f; }
      var daUrl = new URLSearchParams(window.location.search).get('variant');
      if (daUrl && mappa[daUrl] !== undefined) return daUrl;
      var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (campo && campo.value && mappa[campo.value] !== undefined) return campo.value;
      return varianteCorrente;
    }

    function htmlLabel(stato) {
      if (!stato) return '';
      var testo = stato === 'limitata' ? TESTI[lingua] : (stato === 'coming_soon' ? 'Coming soon' : 'Sold out');
      return '<span class="peanuts-label peanuts-label--' + stato + '" data-peanuts-label>' + testo + '</span>';
    }

    function aggiorna() {
      varianteCorrente = leggiVariante();
      var stato = mappa[varianteCorrente] || '';
      azione.setAttribute('data-stato', stato);
      azione.setAttribute('data-variante', varianteCorrente);
      slotLabel.forEach(function (s) { s.innerHTML = htmlLabel(stato); });
      var nascondi = stato === 'coming_soon' || stato === 'sold_out';
      document.querySelectorAll(PEANUTS_SELETTORE_ACQUISTO).forEach(function (el) {
        el.classList.toggle('peanuts-acquisto-nascosto', nascondi);
      });
    }

    /* Cambio variante */
    ['pushState', 'replaceState'].forEach(function (m) {
      var originale = history[m];
      history[m] = function () {
        var r = originale.apply(this, arguments);
        window.dispatchEvent(new Event('peanuts:url'));
        return r;
      };
    });
    window.addEventListener('peanuts:url', function () { setTimeout(aggiorna, 30); });
    window.addEventListener('popstate', aggiorna);
    document.addEventListener('change', function (e) {
      if (e.target.closest('form[action*="/cart/add"], variant-picker, .product-info')) setTimeout(aggiorna, 60);
    });
    /* Evento del tema Enterprise: event.detail.variant è la variante selezionata.
       Le varianti di altri prodotti (quick buy) non sono nella mappa e vengono ignorate. */
    document.addEventListener('on:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || mappa[String(v.id)] === undefined) return;
      varianteForzata = String(v.id);
      aggiorna();
    });
    aggiorna();

    /* Finestra con il form Klaviyo */
    if (!modale) return;
    /* La finestra nasce dentro la sezione prodotto, che ha un suo livello: spostata nel body
       resta sopra header e colonne della pagina. */
    if (modale.parentElement !== document.body) document.body.appendChild(modale);
    var ultimoFocus = null;

    function apri() {
      ultimoFocus = document.activeElement;
      modale.setAttribute('data-modo', azione.getAttribute('data-stato') === 'sold_out' ? 'sold_out' : 'coming_soon');
      modale.hidden = false;
      document.body.classList.add('peanuts-modale-aperta');
      var chiudi = modale.querySelector('.peanuts-modale__chiudi');
      if (chiudi) chiudi.focus();
    }
    function chiudi() {
      modale.hidden = true;
      document.body.classList.remove('peanuts-modale-aperta');
      if (ultimoFocus) ultimoFocus.focus();
    }

    document.querySelectorAll('[data-peanuts-apri]').forEach(function (b) { b.addEventListener('click', apri); });
    modale.querySelectorAll('[data-peanuts-chiudi]').forEach(function (b) { b.addEventListener('click', chiudi); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modale.hidden) chiudi(); });

    /* Invio del form Klaviyo nella finestra: evento con prodotto e variante richiesti */
    var formNostri = [modale.getAttribute('data-form-cs'), modale.getAttribute('data-form-so')].filter(Boolean);
    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail || {};
      if (d.type !== 'submit' || formNostri.indexOf(d.formId) === -1) return;
      var proprieta = {
        ProductID: modale.getAttribute('data-prodotto-id'),
        ProductName: modale.getAttribute('data-prodotto-nome'),
        ProductURL: modale.getAttribute('data-prodotto-url'),
        VariantID: varianteCorrente,
        Stato: modale.getAttribute('data-modo'),
        Lingua: lingua
      };
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(EVENTO_KLAVIYO, proprieta);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', EVENTO_KLAVIYO, proprieta]);
      }
      /* Solo Coming soon: il Sold out definitivo non torna, quindi niente Back in Stock */
      var email = d.metaData && d.metaData.$email;
      if (proprieta.Stato === 'coming_soon' && email && varianteCorrente) iscriviBackInStock(email, varianteCorrente);
    });
  }

  /* PARTE KLAVIYO · iscrizione al Back in Stock nativo della variante (Client API, company ID
     dello script onsite). Genera la metrica "Subscribed to Back in Stock" che fa partire il flow
     Back in Stock di Klaviyo quando la giacenza della variante torna sopra zero. */
  var KLAVIYO_COMPANY_ID = 'SiNNyN';

  function iscriviBackInStock(email, varianteId) {
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + varianteId } }
          }
        }
      })
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
